document.addEventListener("DOMContentLoaded", () => {
  const megaMenus = document.querySelectorAll(".mega-menu");

  megaMenus.forEach((menu) => {
    const level1Items = menu.querySelectorAll(".level-1 li");
    const level2Panels = menu.querySelectorAll(".level-2 .submenu-panel");
    const level3Panels = menu.querySelectorAll(".level-3 .submenu-panel");

    function resetSelections() {
      level1Items.forEach((i) => i.classList.remove("mega-selected"));
      menu
        .querySelectorAll(".level-2 li")
        .forEach((i) => i.classList.remove("mega-selected"));
    }

    /* -------- OPEN MENU -------- */

    menu.addEventListener("mouseenter", () => {
      let activeLink = menu.querySelector(".mega-menu__link--active");

      if (activeLink) {
        /* detect active hierarchy */

        let level3Item = activeLink.closest(".level-3 li");
        let level2Item = activeLink.closest(".level-2 li");

        if (level3Item) {
          let submenuPanel = level3Item.closest(".submenu-panel");

          let menuIndex = submenuPanel.dataset.menu;
          let submenuIndex = submenuPanel.dataset.submenu;

          /* activate correct panels */

          level2Panels.forEach((p) => {
            p.classList.toggle("active", p.dataset.menu === menuIndex);
          });

          level3Panels.forEach((p) => {
            p.classList.toggle(
              "active",
              p.dataset.menu === menuIndex &&
                p.dataset.submenu === submenuIndex,
            );
          });

          /* mark parents selected */

          let level1Item = menu.querySelector(
            `.level-1 li[data-menu="${menuIndex}"]`,
          );
          let level2ItemParent = menu.querySelector(
            `.level-2 ul[data-menu="${menuIndex}"] li[data-submenu="${submenuIndex}"]`,
          );

          resetSelections();

          if (level1Item) level1Item.classList.add("mega-selected");
          if (level2ItemParent) level2ItemParent.classList.add("mega-selected");

          return;
        }
      }

      /* fallback → open first */

      let firstLevel1 = level1Items[0];

      if (!firstLevel1) return;

      let menuIndex = firstLevel1.dataset.menu;

      resetSelections();

      firstLevel1.classList.add("mega-selected");

      level2Panels.forEach((panel) => {
        panel.classList.toggle("active", panel.dataset.menu === menuIndex);
      });

      /* open first level2 */

      let firstPanel = menu.querySelector(
        `.level-2 ul[data-menu="${menuIndex}"]`,
      );
      let firstLevel2 = firstPanel ? firstPanel.querySelector("li") : null;

      if (firstLevel2) {
        firstLevel2.classList.add("mega-selected");

        let submenuIndex = firstLevel2.dataset.submenu;

        level3Panels.forEach((panel) => {
          panel.classList.toggle(
            "active",
            panel.dataset.menu === menuIndex &&
              panel.dataset.submenu === submenuIndex,
          );
        });
      }
    });

    /* -------- LEVEL 1 HOVER -------- */

    level1Items.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        let menuIndex = item.dataset.menu;

        resetSelections();

        item.classList.add("mega-selected");

        level2Panels.forEach((panel) => {
          panel.classList.toggle("active", panel.dataset.menu === menuIndex);
        });

        level3Panels.forEach((panel) => panel.classList.remove("active"));
      });
    });

    /* -------- LEVEL 2 HOVER -------- */

    menu.querySelectorAll(".level-2 li").forEach((item) => {
      item.addEventListener("mouseenter", () => {
        let submenuIndex = item.dataset.submenu;
        let menuIndex = item.closest(".submenu-panel").dataset.menu;

        menu
          .querySelectorAll(".level-2 li")
          .forEach((i) => i.classList.remove("mega-selected"));

        item.classList.add("mega-selected");

        level3Panels.forEach((panel) => {
          panel.classList.toggle(
            "active",
            panel.dataset.menu === menuIndex &&
              panel.dataset.submenu === submenuIndex,
          );
        });
      });
    });
  });
});